export enum MoedaVendaEnum {
  BRL = 1,
  USD,
  EUR,
  CLP,
  PEN,
  COP,
  MXN,
  CAD,
  JPY,
  GBP,
  DKK,
  NOK,
  SEK,
  PYG,
  CHF,
}

export const MoedaVendaDescricao: {
  [key in MoedaVendaEnum]: string;
} = {
  [MoedaVendaEnum.BRL]: 'BRL',
  [MoedaVendaEnum.USD]: 'USD',
  [MoedaVendaEnum.EUR]: 'EUR',
  [MoedaVendaEnum.CLP]: 'CLP',
  [MoedaVendaEnum.PEN]: 'PEN',
  [MoedaVendaEnum.COP]: 'COP',
  [MoedaVendaEnum.MXN]: 'MXN',
  [MoedaVendaEnum.CAD]: 'CAD',
  [MoedaVendaEnum.JPY]: 'JPY',
  [MoedaVendaEnum.GBP]: 'GBP',
  [MoedaVendaEnum.DKK]: 'DKK',
  [MoedaVendaEnum.NOK]: 'NOK',
  [MoedaVendaEnum.SEK]: 'SEK',
  [MoedaVendaEnum.PYG]: 'PYG',
  [MoedaVendaEnum.CHF]: 'CHF',
};
